import type * as SchemaTypes from '../types';

import type { TranslatedTextDataFragment } from './TranslationTextData';
import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import { gql } from '@apollo/client';
import { TranslatedTextDataFragmentDoc } from './TranslationTextData';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
export type FinderApplicationModuleEmailContentSpecsFragment = (
  { __typename: 'FinderApplicationModuleEmailContents' }
  & { submitOrder: (
    { __typename: 'FinderApplicationModuleSubmitOrderContent' }
    & Pick<SchemaTypes.FinderApplicationModuleSubmitOrderContent, 'isSummaryVehicleVisible'>
    & { subject: (
      { __typename: 'DealerTranslationText' }
      & TranslatedTextDataFragment
    ), introTitle: (
      { __typename: 'DealerTranslationText' }
      & TranslatedTextDataFragment
    ), introImage?: SchemaTypes.Maybe<(
      { __typename: 'UploadedFileWithPreview' }
      & UploadFileWithPreviewFormDataFragment
    )>, contentText: (
      { __typename: 'DealerTranslationText' }
      & TranslatedTextDataFragment
    ) }
  ), reminderEmail: (
    { __typename: 'FinderApplicationModuleReminderEmailContent' }
    & Pick<SchemaTypes.FinderApplicationModuleReminderEmailContent, 'sendingTime' | 'active'>
    & { subject: (
      { __typename: 'DealerTranslationText' }
      & TranslatedTextDataFragment
    ), introTitle: (
      { __typename: 'DealerTranslationText' }
      & TranslatedTextDataFragment
    ), introImage?: SchemaTypes.Maybe<(
      { __typename: 'UploadedFileWithPreview' }
      & UploadFileWithPreviewFormDataFragment
    )>, contentText: (
      { __typename: 'DealerTranslationText' }
      & TranslatedTextDataFragment
    ) }
  ) }
);

export const FinderApplicationModuleEmailContentSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment FinderApplicationModuleEmailContentSpecs on FinderApplicationModuleEmailContents {
  submitOrder {
    subject {
      ...TranslatedTextData
    }
    introTitle {
      ...TranslatedTextData
    }
    introImage {
      ...UploadFileWithPreviewFormData
    }
    contentText {
      ...TranslatedTextData
    }
    isSummaryVehicleVisible
  }
  reminderEmail {
    subject {
      ...TranslatedTextData
    }
    introTitle {
      ...TranslatedTextData
    }
    introImage {
      ...UploadFileWithPreviewFormData
    }
    contentText {
      ...TranslatedTextData
    }
    sendingTime
    active
  }
}
    `;